module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info_block"
  }, [_c('h4', {
    staticClass: "info_block_heading"
  }, [_vm._v(_vm._s(_vm.$t("profile.delete_account.heading")))]), _vm._v(" "), _c('p', {
    staticClass: "info_block_desc"
  }, [_vm._v(_vm._s(_vm.$t("profile.delete_account.why_explain")))]), _vm._v(" "), _c('div', {
    staticClass: "mb-24"
  }), _vm._v(" "), _c('LkButton', {
    attrs: {
      "isSecondary": true
    },
    on: {
      "onClick": _vm.onClick
    },
    scopedSlots: _vm._u([{
      key: "prefixIcon",
      fn: function() {
        return [_c('TrashBasketIcon')]
      },
      proxy: true
    }])
  }, [_vm._v("\n    " + _vm._s(_vm.$t("profile.delete")) + " акаунт\n  ")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "isShowModal": _vm.isShowModal
    },
    on: {
      "onClose": function($event) {
        _vm.isShowModal = false
      },
      "showModalAfterRequest": _vm.modalCrmResponse
    }
  }), _vm._v(" "), _c('ModalCrmResponse', {
    attrs: {
      "isShowModal": _vm.isShowModalAfterCrmResponse
    },
    on: {
      "onClose": function($event) {
        _vm.isShowModalAfterCrmResponse = false
      }
    }
  }), _vm._v(" "), _c('DataForCRM')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58ce021a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-page/impl/delete-account/index.vue
// module id = 416
// module chunks = 1